module.exports = __webpack_public_path__ + "img/william-howard-taft.1cf62c38.png";